import { render, staticRenderFns } from "./dijes.vue?vue&type=template&id=7007be70&scoped=true"
import script from "./dijes.vue?vue&type=script&lang=js"
export * from "./dijes.vue?vue&type=script&lang=js"
import style0 from "./dijes.vue?vue&type=style&index=0&id=7007be70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007be70",
  null
  
)

export default component.exports